import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    viewportSmall: true;
    viewportMobileMid: true;
    viewportMedium: true;
    viewportMediumMid: true;
    viewportLarge: true;
    viewportXLarge: true;
    viewportXXLarge: true;
  }
}

export const appBreakpoints = {
  values: {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1024,
    xl: 1400,
    viewportSmall: 375,
    viewportMobileMid: 550,
    viewportMedium: 768,
    viewportMediumMid: 976,
    viewportLarge: 1024,
    viewportXLarge: 1400,
    viewportXXLarge: 1920,
  },
};

export const globalTheme = createTheme({
  breakpoints: appBreakpoints,
});
